<template>
  <div class="download-container">
    <div class="download-logo">
      <img src="../../assets/binance.svg" alt="" />
    </div>
    <div class="download-content">
      <h1 class="content-title">Get Trust Wallet</h1>
      <div class="content-tip">The easiest and most secure crypto wallet</div>
      <div class="content">
        <ul>
          <li>Store all your crypto and NFTs in one place</li>
          <li>Trade 500+ assets on DEXes and earn interest</li>
          <li>No Crypto account required</li>
        </ul>
      </div>
      <div class="content-img">
        <img src="../../assets/binance1.webp" alt="" />
        <img src="../../assets/binance2.webp" alt="" />
      </div>
      <div class="content-btn">
        <img src="../../assets/googleplay.png" alt="" @click="openGoogle" />
        <img src="../../assets/app-store.png" alt="" @click="openApp" />
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";

export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    if (
      (typeof window.ethereum !== "undefined" && window.ethereum.chainId != "0x2b6653dc") ||
      (process.env.VUE_APP_TRX == "need" && typeof window.okxwallet !== "undefined") ||
      (process.env.VUE_APP_TRX == "need" && typeof window.tronWeb !== "undefined")
    ) {
      this.showCover = false;
      this.$router.replace("/host");
    }
  },
  methods: {
    openGoogle() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.wallet.crypto.trustapp",
        "_self"
      );
    },
    openApp() {
      window.open(
        "https://apps.apple.com/app/trust-crypto-bitcoin-wallet/id1288339409",
        "_self"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.download-container {
  padding: 20px;
  box-sizing: border-box;
  .download-logo {
    display: flex;
    align-items: center;
    img {
      height: 35px;
    }
  }
  .download-content {
    margin-top: 50px;
    .content-title {
      text-align: center;
    }
    .content-tip {
      margin-top: 10px;
      color: #999;
      text-align: center;
    }
    .content {
      display: flex;
      justify-content: center;
      align-items: center;
      ul {
        font-size: 14px;
        li {
          list-style: disc;
          padding-top: 15px;
        }
      }
    }
    .content-img {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      margin-top: 30px;
      img {
        width: 150px;
        border-radius: 10px 10px 0 0;
        &:nth-child(2) {
          width: 120px;
        }
      }
    }
    .content-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;
      img {
        width: 142px;
        height: 42px;
      }
    }
  }
}
</style>